module.exports = __webpack_public_path__ + "img/ENVT-logo-RVB.16decc5c.png";